import { render, staticRenderFns } from "./EmailTabs.vue?vue&type=template&id=2a954675&"
import script from "./EmailTabs.vue?vue&type=script&lang=js&"
export * from "./EmailTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports